import { render } from "./animation-wrap.vue?vue&type=template&id=dde5e350&scoped=true"
import script from "./animation-wrap.vue?vue&type=script&lang=js"
export * from "./animation-wrap.vue?vue&type=script&lang=js"

import "./animation-wrap.vue?vue&type=style&index=0&id=dde5e350&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dde5e350"]])

export default __exports__